module.exports = __webpack_public_path__ + "static/img/slide_6.481396a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_6.png
// module id = jjrB
// module chunks = 0